import { useCallback, useEffect, useState } from 'react';

import { AutoComplete, AutoCompleteProps } from 'primereact/autocomplete';

import { useLazySearchShipmentGroupsQuery } from '@/app/services/lookups';
import { MIN_SEARCH_LENGTH, SELECTION_LIMIT } from '@/constants';
import { ShipmentGroup } from '@/rtk-query.gql';

import './ShipmentGroupAutoComplete.css';

type ShipmentGroupAutoCompleteProps = AutoCompleteProps & {
  className?: string;
  label?: string;
  defaultValue?: ShipmentGroup;
};

export const ShipmentGroupAutoComplete = ({
  className,
  label,
  defaultValue,
  ...autoCompleteProps
}: ShipmentGroupAutoCompleteProps) => {
  const [selected, setSelected] = useState<ShipmentGroup | undefined>(
    defaultValue,
  );
  const [inputValue, setInputValue] = useState<string>(
    defaultValue?.name || '',
  );
  const [filtered, setFiltered] = useState<ShipmentGroup[]>([]);

  const [query] = useLazySearchShipmentGroupsQuery();

  useEffect(() => {
    setSelected(defaultValue);
    setInputValue(defaultValue?.name || '');
  }, [defaultValue]);

  const search = useCallback(
    async (event: { query: string }) => {
      const { data = [] } = await query({
        search: event.query || '',
        selectionLimit: SELECTION_LIMIT,
      });

      setFiltered(data);
    },
    [query],
  );

  const handleSelect = (e: { value: ShipmentGroup }) => {
    setSelected(e.value);
    setInputValue(e.value?.name || '');
  };

  const handleChange = (e: { value: string }) => {
    setInputValue(e.value);
  };

  return (
    <div
      className={`[ shipment-group-auto-complete ] [${className ? ` ${className}` : ''} label-input-group ]`}
    >
      {label && <label>{label}</label>}
      <AutoComplete
        appendTo="self"
        suggestions={filtered}
        minLength={MIN_SEARCH_LENGTH}
        selectionLimit={SELECTION_LIMIT}
        completeMethod={search}
        onSelect={handleSelect}
        onChange={handleChange}
        dropdown={true}
        {...autoCompleteProps}
        value={inputValue}
      />
    </div>
  );
};
